
import * as fU from '../../utility/fileUtility'
import { snakeToCamel, camelToSnake } from '../../utility/stringUtility'
import linq from 'linq'
import Model from './Model';

export default class ImageUploadable extends Model{

    constructor (data = null) {
        super()
        this.originalData = data

        this.file = null
        this.blobImage = ''
        this.path = '/img/noimage.png'

        this.fillable = ['blobImage', 'path']

        if (data) {
            this.create()
        }
    }

    get _model () {
        return 'ImageUploadable'
    }

    get imageView () {
        if (this.file) {
            fU.bindResult(this.file, (p) => this.blobImage = p)
            return this.blobImage
        }

        return this.path
    }

    get has () {
        return this.path !== '/img/noimage.png' || this.file
    }

    get data () {
        return this.originalData
    }

    imageCreate (event) {
        this.file = fU.getFile(event).first()
    }

    addFillable (fill) {
        this.fillable.push(...fill)
    }

    getPostable () {
        return linq.from(this)
            .where(x => x.value)
            .where(x => linq.from(this.fillable).any(xs => xs === x.key))
            .select(x => {
                const key = camelToSnake(x.key)
                return {
                    key: key, value: x.value
                }
            })
            .toObject('$.key', '$.value')
    }

    create () {
        linq.from(this.data)
            .select(x => {
                x.key = camelToSnake(x.key)
                return x
            })
            .where(x => {
                return this.hasOwnProperty(snakeToCamel(x.key))
            })
            .select(x => {
                const key = snakeToCamel(x.key)
                this[key] = x.value
                return x
            })
            .toArray()
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/models/Parents/ImageUploadable.js